
import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from '../CmsBlockMixin';

@Component
export default class ContactsBlock extends mixins(BaseCmsBlock) {}
